import { useContext, useEffect, useRef } from 'react';

import { ModalContext } from '../ModalManager';
import { subscribeForumCertification } from '../../../libs/forumCertification';
import { FORUM_CERTIFICATION_MODAL } from '../../../hooks/useForumCertification';

/**
 * Filet de sécurité du forum réservé aux certifiés : ouvre la modale quand l'API a refusé une
 * publication (code `FORUM_CERTIFICATION_REQUIRED`), pour les chemins qui ne sont pas gatés au clic
 * — upload d'image depuis l'éditeur, ou cache `currentUser` antérieur à une révocation de certif.
 *
 * Ne rend rien ; à monter une seule fois, SOUS le ModalManager (cf. src/index.js). L'émetteur est
 * le MutationCache de React Query, qui vit hors de l'arbre React et ne peut pas ouvrir de modale
 * lui-même.
 */
const ForumCertificationListener = () => {
    const { openModal } = useContext(ModalContext);

    // Le ModalManager recrée `openModal` à chaque rendu : passer par une ref évite de
    // désabonner/réabonner en boucle.
    const openModalRef = useRef(openModal);
    openModalRef.current = openModal;

    useEffect(() => subscribeForumCertification(() => openModalRef.current(FORUM_CERTIFICATION_MODAL)), []);

    return null;
};

export default ForumCertificationListener;
